<template>
  <div class="invite-poster">
    <div class="poster-list">
      <div class="poster" v-for="(poster, i) of posterInfoList" :key="i">
        <div class="poster-picture" :name="`${poster.name && poster.name + poster.title}`">
          <div class="cover-mask">
            <div class="delete" @click="removePoster(i)">删除</div>
          </div>
          <img class="img" src="../../assets/images/invite/poster.png" alt="" srcset="" />
          <div class="info">
            <span class="info-label">诚挚邀请</span>
            <p
              class="info-name"
              :class="{
                'small-size': poster.name.length + poster.title.length > 10,
              }"
            >
              {{ poster.name }}{{ poster.title }}
            </p>
            <!-- <span class="info-title">
              {{ poster.title }}
            </span> -->
          </div>
        </div>
        <div class="poster-info-editor">
          <p class="label required">受邀人</p>
          <input
            type="text"
            :class="{ 'is-invalid': poster.isInValidName }"
            @input="onPosterNameInput(poster)"
            maxlength="10"
            minlength="2"
            class="name"
            v-model.trim="poster.name"
            placeholder="不能多于10个字，低于2个字"
          />
          <p class="label">称谓</p>
          <input type="text" maxlength="2" class="title" v-model.trim="poster.title" placeholder="不能多于2个字" />
          <p class="tip">例如：女士、先生、老师...</p>
        </div>
        <div class="copy-tools-wrapper" v-if="i === posterInfoList.length - 1">
          <div class="copy-tool">
            复制<span class="input-square"
              ><input type="text" v-model="designNum" v-force-input-number /><i
                class="increase iconfont icon-fangxiang"
                @click="designNum++"
              ></i
              ><i class="reduce iconfont icon-fangxiang" @click="designNum > 0 ? designNum-- : 0"></i></span
            >个<span class="btn" @click="onCopy">确定</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-download-bar">
      <div class="download-btn" :class="{ 'is-disabled': isDisableDownload }" @click="downloadPoster">下载</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import saveAs from "file-saver";
import html2canvas from "html2canvas";
import JSZip from "jszip";
export default {
  name: "InvitePoster",

  data() {
    return {
      designNum: 1,
      posterInfoList: [
        {
          name: "",
          title: "",
          isInValidName: false,
        },
      ],
    };
  },

  computed: {
    isDisableDownload() {
      return this.posterInfoList.some(info => !info.name);
    },
  },

  mounted() {},

  methods: {
    onPosterNameInput(poster) {
      if (poster.name.length) {
        poster.isInValidName = false;
      }
    },
    removePoster(index) {
      if (this.posterInfoList.length > 1) {
        this.posterInfoList.splice(index, 1);
      }
    },
    onCopy() {
      const newArr = new Array(+this.designNum)
        .fill("")
        .map(() => JSON.parse(JSON.stringify({ name: "", title: "", isInValidName: false })));
      this.posterInfoList.push(...newArr);
      const newPosterIndex = this.posterInfoList.length;
      this.$nextTick(() => {
        this.scrollToPoster(newPosterIndex - 1);
      });
    },
    scrollToPoster(index) {
      const newPoster = document.querySelectorAll(".poster")[index];
      const posterList = document.querySelector(".poster-list");
      const top = newPoster.getBoundingClientRect().top + newPoster.offsetHeight + posterList.scrollTop;
      posterList.scrollTo({
        top,
        behavior: "smooth",
      });
    },
    createPicture: async container => {
      let canvas = await html2canvas(container, {
        scale: 3,
        useCORS: true,
        allowTaint: true,
        logging: true,
      });
      return new Promise(resolve => {
        canvas.toBlob(blob => resolve(blob));
        canvas.remove();
        canvas = null;
      });
    },
    downloadPicture: (blob, name) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `${name}.png`);
      link.click();
      URL.revokeObjectURL(url);
    },
    checkInputNameValid() {
      this.posterInfoList.forEach((info, index) => {
        if (!info.name.length) {
          info.isInValidName = true;
          this.scrollToPoster(index);
        }
      });
    },
    // 记录新增记录
    logData(count) {
      const name = "85届教育展";
      axios.post("/subject-page-api/poster/add", {
        name,
        count,
      });
    },
    downloadPoster() {
      if (this.isDisableDownload) {
        this.checkInputNameValid();
        return;
      }
      const zip = new JSZip();
      const list = document.querySelectorAll(".poster-picture");
      const pictureList = [...list].filter(pic => pic.getAttribute("name"));
      let createdCount = 0;
      this.logData(pictureList.length);
      pictureList.forEach(picture => {
        const name = picture.getAttribute("name") + ".png";
        this.createPicture(picture).then(blob => {
          if (pictureList.length === 1) {
            this.downloadPicture(blob, picture.getAttribute("name"));
          } else {
            zip.file(name, blob, { base64: true });
            createdCount++;
            if (createdCount === pictureList.length) this.generateZipFile(zip);
          }
        });
      });
    },
    generateZipFile: zip => {
      const date = new Date();
      const zipFileName = `教育装备展邀请函文件（${date.getHours()}时${date.getMinutes()}分生成）.zip`;
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, zipFileName);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-poster {
  margin-top: 40px;
  .poster-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 1380px;
    margin: 0 auto;
    overflow-y: scroll;
    height: calc(100vh - 160px);
    .poster {
      position: relative;
      display: flex;
      margin-bottom: 100px;
      height: fit-content;
      &:nth-child(2n-1) {
        margin-right: 80px;
      }
      .poster-picture {
        width: 300px;
        height: 534px;
        position: relative;
        &:hover {
          .cover-mask {
            transition: all 0.3s;
            display: block;
          }
        }
        .cover-mask {
          display: none;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.8);
          z-index: 100;
          .delete {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 68px;
            border-radius: 23px;
            border: 1px solid #fff;
            color: #fff;
            text-align: center;
            line-height: 28px;
            font-weight: 600;
            z-index: 100;
            cursor: pointer;
            &:hover {
              opacity: 0.8;
            }
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        .info {
          position: absolute;
          top: 260px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          color: #fff;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
          .info-name {
            height: 26px;
            margin: 0 4px;
            // width: 120px;
            padding: 0 16px;
            text-align: center;
            font-size: 18px;
            line-height: 24px;
            border-bottom: 1px solid #fff;
            padding-bottom: 1px;
            min-width: 50px;
            font-weight: 700;
            &.small-size {
              font-size: 15px;
            }
          }
        }
      }
      .poster-info-editor {
        margin-left: 40px;
        width: 310px;
        height: 246px;
        border-radius: 6px;
        padding: 30px;
        background: rgba(255, 255, 255, 0.4);
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.06), 0px 1px 0px 0px #fff inset, -1px -1px 1px 0px #eceef5 inset;
        .label {
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
          margin-bottom: 16px;
          position: relative;
          &.required {
            &::before {
              position: absolute;
              left: -8px;
              content: "*";
              color: #f00;
            }
          }
        }
        .name {
          margin-bottom: 24px;
          &.is-invalid {
            border-color: red;
          }
        }
        .tip {
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
          margin-top: 8px;
          padding-left: 18px;
          color: #b6b8bb;
        }
        input {
          width: 250px;
          height: 40px;
          padding-left: 18px;
          outline: none;
          border-radius: 4px;
          border: 1px solid #6d7278;
          background: #fff;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
        }
      }
    }
  }
  .bottom-download-bar {
    width: 100%;
    position: fixed;
    bottom: 0;
    height: 58px;
    background: rgba(0, 0, 0, 0.8);
    padding-right: 44px;
    .download-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      float: right;
      margin-top: 7px;
      width: 160px;
      height: 44px;
      border-radius: 22px;
      background: #3f69f9;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
      color: white;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &.is-disabled {
        background: #d6dbe0;
        color: #666;
      }
    }
  }
  .copy-tools-wrapper {
    position: absolute;
    bottom: -60px;
    left: 0;
    .copy-tool {
      width: 200px;
      height: 46px;
      line-height: 30px;
      padding: 8px 12px;
      background: #ffffff;
      border-radius: 8px;
      .input-square {
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 64px;
        height: 30px;
        margin: 0 4px;
        border-radius: 3px;
        overflow: hidden;
        border: 1px solid #cacaca;
        input {
          width: 34px;
          height: 100%;
          vertical-align: top;
          border: 0px;
          outline: 0px;
          font-size: 14px;
          text-align: center;
        }
        .increase,
        .reduce {
          position: absolute;
          right: 0;
          width: 30px;
          height: 14px;
          line-height: 14px;
          background: #eceef5;
          font-size: 12px;
          text-align: center;
          cursor: pointer;
          &:hover {
            background: #d2d4d9;
          }
        }
        .increase {
          top: 0;
          &:before {
            display: inline-block;
            transform: rotate(-90deg);
          }
        }
        .reduce {
          bottom: 0;
          &:before {
            display: inline-block;
            transform: rotate(90deg);
          }
        }
      }
      .btn {
        display: inline-block;
        vertical-align: top;
        width: 44px;
        height: 30px;
        background: #3f69f9;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        color: #fff;
        &:hover {
          background: #2753ec;
        }
      }
    }
  }
}
</style>
